import { Form } from 'react-bootstrap'
import Select from 'react-select'
import { IFilterSelectMultiple } from '../../types'
import { ISelectOption } from '../../types/ui'
import uniqid from 'uniqid'
import { useAtomValue } from 'jotai'
import * as state from '../../states'
import { reactSelectStyles } from './filterHelpers'
import { useTranslation } from 'react-i18next'
import { ALL_LANG_KEY } from '../../types/lang'

export const FilterSelectMultiple = (props: IFilterSelectMultiple<string>) => {
	const {
		attr,
		value,
		setValue,
		options,
		label,
		placeholder,
		styles = {},
		isSearchable = false,
		isClearable = false,
		isDisabled = false
	} = props
	const { t } = useTranslation()
	const key = uniqid()
	const isThemeDark = useAtomValue(state.themeIsDarkAtom)
	const foundValue: ISelectOption<string>[] = []

	value?.forEach(valueItem => {
		const temp = options?.find(optionItem => optionItem.value === valueItem)
		if (!!temp) {
			foundValue.push(temp)
		}
	})

	return (
		<div className={'filter-input-cont'} style={styles}>
			{label ? <Form.Label className="text-dark" htmlFor={`select-multiple-${key}`}>{label}</Form.Label> : null}

			<Select
				inputId={`select-multiple-${key}`}
				className="react-select-container"
				classNamePrefix="react-select"
				{...attr}
				options={options}
				value={foundValue}
				placeholder={placeholder ?? `${t(ALL_LANG_KEY.general.react_select_placeholder)}`}
				noOptionsMessage={() => `${t(ALL_LANG_KEY.general.react_select_no_options)}`}
				isSearchable={isSearchable}
				isClearable={isClearable}
				isDisabled={isDisabled}
				isMulti={true}
				styles={reactSelectStyles<ISelectOption<string>, true>(isThemeDark)}
				onChange={(selectedItems) => {
					const selectedItemsMap = selectedItems?.map(item => item.value)
					setValue(selectedItemsMap ?? null)
				}}
			/>
		</div>
	)
}